export type Language = "en" | "de";

interface Translations {
  header: {
    logout: string;
    toLight: string;
    toDark: string;
    settings: string;
    settingsTitle: string;
    settingsLanguage: string;
    exportCsv: string;
  };
  diaryList: {
    title: string;
    newEntry: string;
    loading: string;
    empty: string;
    energyLevel: string;
    avgPeakFlow: string;
    edit: string;
    delete: string;
    deleteConfirm: string;
    na: string;
  };
  diaryForm: {
    titleNew: string;
    titleEdit: string;
    dateTime: string;
    energyLevel: string;
    symptoms: string;
    noSymptoms: string;
    activities: string;
    pauses: string;
    postExertionalMalaise: string;
    sleepNotes: string;
    otherNotes: string;
    peakFlowBeforeSpray: string;
    peakFlowAfterSpray: string;
    cancel: string;
    saving: string;
    saveChanges: string;
    createEntry: string;
    loading: string;
  };
  auth: {
    username: string;
    password: string;
    repeatPassword: string;
    email: string;
    dateOfBirth: string;
    login: string;
    loggingIn: string;
    register: string;
    registering: string;
    noAccount: string;
    registerLink: string;
    haveAccount: string;
    loginLink: string;
  };
}

const en: Translations = {
  header: {
    logout: "Logout",
    toLight: "Switch to light mode",
    toDark: "Switch to dark mode",
    settings: "Settings",
    settingsTitle: "Settings",
    settingsLanguage: "Language",
    exportCsv: "Download diary as CSV",
  },
  diaryList: {
    title: "Diary entries",
    newEntry: "New entry",
    loading: "Loading diaries…",
    empty: "No diary entries yet.",
    energyLevel: "Energy level",
    avgPeakFlow: "Average peak flow",
    edit: "Edit",
    delete: "Delete",
    deleteConfirm: "Delete this diary entry?",
    na: "N/A",
  },
  diaryForm: {
    titleNew: "New diary entry",
    titleEdit: "Edit diary entry",
    dateTime: "Date and time",
    energyLevel: "Energy level (1–10)",
    symptoms: "Symptoms",
    noSymptoms: "No symptoms available.",
    activities: "Activities",
    pauses: "Pauses",
    postExertionalMalaise: "Post-exertional malaise",
    sleepNotes: "Sleep notes",
    otherNotes: "Other notes",
    peakFlowBeforeSpray: "Peak flow (before spray)",
    peakFlowAfterSpray: "Peak flow (after spray)",
    cancel: "Cancel",
    saving: "Saving…",
    saveChanges: "Save changes",
    createEntry: "Create entry",
    loading: "Loading…",
  },
  auth: {
    username: "Username",
    password: "Password",
    repeatPassword: "Repeat password",
    email: "Email",
    dateOfBirth: "Date of birth",
    login: "Login",
    loggingIn: "Logging in…",
    register: "Register",
    registering: "Registering…",
    noAccount: "No account?",
    registerLink: "Register",
    haveAccount: "Already have an account?",
    loginLink: "Login",
  },
};

const de: Translations = {
  header: {
    logout: "Abmelden",
    toLight: "Zum hellen Modus wechseln",
    toDark: "Zum dunklen Modus wechseln",
    settings: "Einstellungen",
    settingsTitle: "Einstellungen",
    settingsLanguage: "Sprache",
    exportCsv: "Tagebuch als CSV herunterladen",
  },
  diaryList: {
    title: "Tagebucheinträge",
    newEntry: "Neuer Eintrag",
    loading: "Einträge werden geladen…",
    empty: "Noch keine Tagebucheinträge.",
    energyLevel: "Energielevel",
    avgPeakFlow: "Ø Peakflow",
    edit: "Bearbeiten",
    delete: "Löschen",
    deleteConfirm: "Diesen Tagebucheintrag löschen?",
    na: "N/V",
  },
  diaryForm: {
    titleNew: "Neuer Tagebucheintrag",
    titleEdit: "Tagebucheintrag bearbeiten",
    dateTime: "Datum und Uhrzeit",
    energyLevel: "Energielevel (1–10)",
    symptoms: "Symptome",
    noSymptoms: "Keine Symptome verfügbar.",
    activities: "Aktivitäten",
    pauses: "Pausen",
    postExertionalMalaise: "Belastungsinduzierte Verschlechterung (PEM)",
    sleepNotes: "Schlafnotizen",
    otherNotes: "Sonstige Notizen",
    peakFlowBeforeSpray: "Peakflow (vor Spray)",
    peakFlowAfterSpray: "Peakflow (nach Spray)",
    cancel: "Abbrechen",
    saving: "Speichern…",
    saveChanges: "Änderungen speichern",
    createEntry: "Eintrag erstellen",
    loading: "Laden…",
  },
  auth: {
    username: "Benutzername",
    password: "Passwort",
    repeatPassword: "Passwort wiederholen",
    email: "E-Mail",
    dateOfBirth: "Geburtsdatum",
    login: "Anmelden",
    loggingIn: "Anmelden…",
    register: "Registrieren",
    registering: "Registrieren…",
    noAccount: "Noch kein Konto?",
    registerLink: "Registrieren",
    haveAccount: "Bereits ein Konto?",
    loginLink: "Anmelden",
  },
};

export const translations: Record<Language, Translations> = { en, de };
